import { put, takeLatest, call } from 'redux-saga/effects'
import { Action } from 'redux'
import * as errorHandler from 'utils/error-handler'
import { ServiceActionsTypes } from './actions'
import * as api from './api'

import { IServiceAction } from 'models/service'

const getLocations = function* (action: IServiceAction) {
  try {
    const { data } = yield call(api.getLocations, action.connectionType)

    yield put({
      type: ServiceActionsTypes.SERVICE_GET_LOCATIONS_SUCCESS,
      locations: data.data,
    })
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: ServiceActionsTypes.SERVICE_GET_LOCATIONS_FAIL },
      e
    )
    yield put(handledAction)
  }
}

const getLocationTargets = function* (action: IServiceAction) {
  try {
    const { data } = yield call(api.getLocationTargets, action.data)

    const shouldUpdateRegions = !action.data.region && !action.data.city
    const shouldUpdateCities = !action.data.city

    if (shouldUpdateRegions) {
      yield put({
        type: ServiceActionsTypes.SERVICE_GET_UPDATE_LOCATION_REGIONS,
        regions: data.regions,
      })
    }

    if (shouldUpdateCities) {
      yield put({
        type: ServiceActionsTypes.SERVICE_GET_UPDATE_LOCATION_CITIES,
        cities: data.cities,
      })
    }

    yield put({
      type: ServiceActionsTypes.SERVICE_GET_UPDATE_LOCATION_ISP,
      isp: data.isp,
    })

    yield put({
      type: ServiceActionsTypes.SERVICE_GET_LOCATION_TARGETS_SUCCESS,
    })
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: ServiceActionsTypes.SERVICE_GET_LOCATION_TARGETS_FAIL },
      e
    )
    yield put(handledAction)
  }
}

const checkProxy = function* (action: IServiceAction) {
  try {
    // @ts-ignore
    const data = yield call(api.checkProxyList, action.proxies)

    yield put({
      type: ServiceActionsTypes.SERVICE_CHECK_PROXY_SUCCESS,
      data: data,
    })
  } catch (e) {
    const handledAction: Action = yield errorHandler.handle(
      { type: ServiceActionsTypes.SERVICE_CHECK_PROXY_FAIL },
      e
    )
    yield put(handledAction)
  }
}

function* serviceSaga() {
  yield takeLatest(ServiceActionsTypes.SERVICE_GET_LOCATIONS, getLocations)
  yield takeLatest(
    ServiceActionsTypes.SERVICE_GET_LOCATION_TARGETS,
    getLocationTargets
  )
  yield takeLatest(ServiceActionsTypes.SERVICE_CHECK_PROXY, checkProxy)
}

export default serviceSaga
